import Metatags from './metatags'

export default Metatags
